import { Row, Col, InputGroup } from 'reactstrap'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import Select from './Select'
import PhoneViewer from 'components/PhoneViewer'
import ModalWrapper from 'components/ModalWrapper'
import { TextNumberFormat } from 'components/Form'
import { chatmailProviders } from 'constants/channels'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { lang } from 'utils/helpers'

const TIMES = {
  seconds: 60,
  minutes: 60,
  hours: 24,
  days: 15,
}


const getTime = (time, unit) => {
  const duration = moment.duration(time || 0, 'milliseconds')

  switch (unit || 'seconds') {
    case 'seconds':
      return duration.asSeconds().toString()
    case 'minutes':
      return duration.asMinutes().toString()
    case 'hours':
      return duration.asHours().toString()
    case 'days':
      return duration.asDays().toString()
    default:
      return '0'
  }
}

/**
 * MsgWithOptions
 * @param {object} props
 * @param {string} props.id
 * @param {string} props.prop
 * @param {object} props.value
 * @param {string} props.value.text
 * @param {string} props.value.unit
 * @param {number} props.value.time
 * @param {string} props.label
 * @param {function} props.onChange
 * @param {String} props.channel
 * @param {Array} props.options
 * @param {String} props.description
 */
const MsgWithOptions = (props) => {
  const { id, value = {}, label, onChange, channel, options, description, required } = props
  const company = useSelector((store) => store.companies)
  const [state, setState] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const onToggleModal = () => setIsModalOpen(!isModalOpen)

  const time = getTime(value.time, value.unit)

  const setUnit = (unit) => {
    // onChange(`${prop}.unit`, unit)
    // onChange({...value, 'unit': unit})

    setTime(
      Number(time) < TIMES[unit] ? time : '0',
      unit
    )
  }

  const setTime = (time, unit) => {
    const newUnit = unit || value.unit || 'seconds'
    const newTime = moment.duration(time, newUnit).asMilliseconds()

    // onChange(`${prop}.time`, newTime)
    onChange({ content: value.content || '',
      contentHtml: value.contentHtml || '',
      buttons: value.buttons || [],
      attachments: value.attachments || [], 'time': newTime, 'unit': newUnit })
    // setState({ content: value.value || '',
    //   contentHtml: value.valueHtml || '',
    //   buttons: value.buttons || [],
    //   attachments: value.attachments || [], 'time': newTime.toString(), 'unit': newUnit})
  }

  /*
  const setText = ({ target }) => {
    if (!value.unit && !value.time) {
      onChange(prop, {
        text: target.value,
        unit: 'minutes',
        time: 60000,
      })
    } else {
      onChange(`${prop}.text`, target.value)
    }
  }
  */

  const onPreviewMsg = () => onToggleModal()

  const withValueCap = (inputObj) => {
    const { value: _value } = inputObj
    if (_value <= TIMES[value.unit || 'seconds']) return true
    return false
  }

  return (
    <div className='channel-field messages'>
      {label && <label htmlFor={id}>{lang(label)} <span className='required'>{required ? '*' : ''}</span></label>}
      <Row className='grid grid--large'>
        <Col>
          <TextEditor2
            id={id}
            company={company}
            channel={chatmailProviders.includes(channel) ? 'chatmail' : channel}
            limit={0}
            value={value.contentHtml || value.content || value.text || ''}
            attachments={value.attachments}
            buttons={value.buttons}
            placeholder={lang('dashboard_greeting-message-example')}
            options={options}
            onChange={(e) => {
              const preview = {
                content: e.value,
                contentHtml: e.valueHtml,
                buttons: e.buttons,
                attachments: e.attachments,
              }
              setState({ ...preview })
              onChange({
                content: e.value,
                contentHtml: e.valueHtml,
                buttons: e.buttons,
                attachments: e.attachments,
                unit: value.unit || 'seconds',
                time: value.time || 0
              })
            }}
            dropZoneFilesHeight={125}
            onPreviewMsg={onPreviewMsg}
            minHeight={120}
            maxHeight={120}
            isTemplateValue
            isSmall
          />
        </Col>
        <Col>
          <p className='description'>{lang(description)}</p>
          { options.find(it => it === 'time') &&
            <InputGroup className='margin-input-group'>
              <div className='number'>
                <TextNumberFormat
                  defaultValue={time || '0'}
                  id={`${id}_time`}
                  onChange={_value => !isNaN(_value) && setTime(_value)}
                  className={'new-input'}
                  decimalScale={0}
                  isAllowed={withValueCap}
                />
              </div>
              <Select
                id={`${id}_unit`}
                name={`${id}_unit`}
                value={value.unit || 'seconds'}
                onChange={(value) => setUnit(value)}
                options={[
                  { value: 'seconds', label: lang(`dashboard_seconds`) },
                  { value: 'minutes', label: lang(`dashboard_minutes`) },
                  { value: 'hours', label: lang(`dashboard_hours`) },
                  { value: 'days', label: lang(`dashboard_days`) }
                ]}
              />
            </InputGroup>
          }
        </Col>
      </Row>
      <ModalWrapper
        isOpen={isModalOpen}
        toggle={onToggleModal}
        header={lang('dashboard_preview')}
        body={
          <div className='modal-content'>
            <PhoneViewer
              textPreview={state}
              channel={chatmailProviders.includes(channel) ? 'chatmail' : channel}
              previewMsg
            />
          </div>
        }
        eventBtnTxt={lang('dashboard_close')}
        eventBtn={onToggleModal}
        contentClassName='modal-content-phone-preview'
      />
    </div>
  )
}

export default MsgWithOptions
